module.exports = __webpack_public_path__ + "img/fondo_desktop.bb0e9dc2.png";